import { Heading, Text } from '@ui/themed';
import { t } from 'i18next';
import type { TeamOwnerApiResponse } from '../../types';

export function OwnerDetails({
  owner,
  companyName,
}: {
  owner: TeamOwnerApiResponse;
  companyName?: string;
  showRole?: boolean;
}) {
  return (
    <div className="grid gap-x-4 gap-y-4 pt-3 sm:grid-cols-3">
      <div>
        <Heading style="sm" level="h3">
          {t('features:account.components.member_details.section_titles.name')}
        </Heading>
        <Text variant="secondary">{owner.name}</Text>
      </div>
      <div>
        <Heading style="sm" level="h3">
          {t('features:account.components.member_details.section_titles.email')}
        </Heading>
        <Text variant="secondary">{owner.email}</Text>
      </div>
      <div>
        <Heading style="sm" level="h3">
          {t('features:account.components.member_details.section_titles.company_name')}
        </Heading>
        <Text variant="secondary">{companyName}</Text>
      </div>
    </div>
  );
}
